<template>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ $t('sdl.gcrm.common.notice.details') }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="ly-noti-wrap">
          <table v-if="notice.noticeId" class="table hori">
            <colgroup>
              <col style="width: 200px" />
              <col style="width: auto" />
              <col style="width: 200px" />
              <col style="width: auto" />
            </colgroup>
            <tbody>
              <tr>
                <th>
                  {{ $t('sdl.gcrm.common.importance') }}
                </th>
                <td colspan="3">
                  {{ !Number(notice.importantYn) ? $t('sdl.gcrm.common.general') : $t('sdl.gcrm.common.important') }}
                </td>
              </tr>
              <tr>
                <th>
                  {{ $t('sdl.gcrm.common.platform') }}
                </th>
                <td>
                  {{ getLabel({ labelJson: JSON.parse(notice.platformCodeLabelJson) }) }}
                </td>
                <th>
                  {{ $t('sdl.gcrm.common.region') }}
                </th>
                <td>
                  {{ getLabel({ labelJson: JSON.parse(notice.regionCodeLabelJson) }) }}
                </td>
              </tr>
              <tr>
                <th>
                  {{ $t('sdl.gcrm.common.date') }}
                </th>
                <td>
                  {{ notice.firstRegDatetime | dateFormat($t('data-format.date.ymd')) }}
                </td>
                <th>
                  {{ $t('sdl.gcrm.common.registrar') }}
                </th>
                <td>
                  {{ notice.firstRegrName }}
                </td>
              </tr>
              <tr>
                <th>
                  {{ $t('sdl.gcrm.common.subject') }}
                </th>
                <td colspan="3">
                  {{ notice.title }}
                </td>
              </tr>
              <tr>
                <th>
                  {{ $t('sdl.gcrm.common.content') }}
                </th>
                <td colspan="3" v-html="notice.contents"></td>
              </tr>
              <tr>
                <th>
                  {{ $t('sdl.common.label.attachments') }}
                </th>
                <td colspan="3">
                  <!-- 퍼블 확인용 샘플 -->
                  <sdl-fileuploader
                    ref="fileUploader"
                    :fileList="attachments"
                    downloadType="NOTICE"
                    :maxTotalSize="1073741824"
                    :modifyFlag="false"
                    useExtList="zip|xlsx|xls|ppt|pptx"
                  ></sdl-fileuploader>
                  <!-- //퍼블 확인용 샘플 -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="$emit('close')">
          {{ $t('sdl.common.label.close') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { SDLUtil } from '@/utils';
import SDLLocale from '@/mixin/SDLLocale';

export default {
  mixins: [SDLLocale],
  props: {
    noticeId: {
      type: String,
    },
  },
  mounted() {
    this.$nextTick(async () => {
      await this.getContents();
    });
  },
  data() {
    return {
      notice: {},
      attachments: [],
    };
  },
  methods: {
    async getContents() {
      SDLUtil.showLoadingBar(true);
      const res = await axios.get(`${SDLUtil.API_URL}/gcrm/about/notice/${this.noticeId}`).catch(err => {
        SDLUtil.showLoadingBar(false);
        SDLUtil.errorAlert(err);
        return err.response;
      });
      if (res.status === 200) {
        this.notice = { ...res.data.notice };
        this.attachments = [...this.notice.attachments];
      }
      SDLUtil.showLoadingBar(false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/popup/NoticePopup.vue